/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { css } from "styled-components";
import styled from "styled-components";
import { useState } from "react";
import { useEventListener } from "hooks/useEventListener";

const MOBILE_BREAKPOINT = 768;

export const breakpoints = {
  small: `(max-width: ${MOBILE_BREAKPOINT}px)`,
  medium: `(max-width: 1000px)`,
  large: `(min-width: ${MOBILE_BREAKPOINT}px)`,
};

export const devices = {
  small: `@media only screen and ${breakpoints.small}`,
  medium: `@media only screen and ${breakpoints.large} and ${breakpoints.medium}`,
  large: `@media only screen and ${breakpoints.large}`,
};

export const fontFamilies = "adobe-clean, sans-serif";

export const isMobileSize = (): boolean =>
  window.innerWidth <= MOBILE_BREAKPOINT;

export const useScreenSize = (): number => {
  const [_, setTick] = useState(0);
  useEventListener(
    "resize",
    () => {
      setTick((tick) => tick + 1);
    },
    window
  );

  return window.innerWidth;
};

export const useIsMobile = (): boolean => {
  useScreenSize();

  return isMobileSize();
};

export const flex_centered = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonImageWrapper = styled.div`
  padding: 0 10px;
  display: flex;
  align-items: start;

  & > img {
    margin-right: 8px;
    width: 18px;
    height: 18px;
  }
`;
